import React, { PropsWithChildren, useMemo } from 'react';

import { Link } from 'gatsby';

import { Button } from '../web';

interface HeroProps extends PropsWithChildren {
  className?: string;
  childrenClassName?: string;
  title: string;
  subtitle: string;
  ctaText: string;
  ctaLink: string;
  ctaDescription?: string;
  ctaCallback?: () => void;
}

const Hero = (props: HeroProps) => {
  const containerClass = useMemo(
    () =>
      props.className
        ? [classNames.container, props.className].join(' ')
        : classNames.container,
    [props.className],
  );

  return (
    <div className={containerClass}>
      <div className={classNames.textContainer}>
        <h1 className="tw-display2-teodor">{props.title}</h1>
        <span className="tw-h3">
          {props.subtitle}
          {props.ctaDescription && (
            <span className="tw-h3-emphasis">
              <br />
              <br />
              {props.ctaDescription}
            </span>
          )}
        </span>
        <Link to={props.ctaLink}>
          <Button
            preset="primary"
            text={props.ctaText}
            className={classNames.button}
            onClick={props.ctaCallback}
          />
        </Link>
      </div>
      {props.children}
    </div>
  );
};

const classNames = {
  container: [
    'tw-flex',
    'tw-flex-col-reverse',
    'lg:tw-flex-row',
    'tw-gap-[32px]',
    'md:tw-gap-[40px]',
    'lg:tw-gap-[24px]',
    'lg:tw-max-w-[1128px]',
  ].join(' '),
  textContainer: [
    'tw-flex',
    'tw-text-center',
    'lg:tw-text-left',
    'tw-items-center',
    'lg:tw-items-start',
    'tw-flex-1',
    'tw-flex-col',
    'tw-gap-[24px]',
  ].join(' '),
  button: ['tw-flex-1', 'tw-mt-[8px]', 'md:tw-mt-[16px]'].join(' '),
};

export { Hero };
export type { HeroProps };
